<template>
  <div>
    <div v-if="loading" class="d-flex justify-center align-center">
      <v-progress-circular :size="50" indeterminate color="primary"></v-progress-circular>
    </div>

    <v-tabs
      background-color="primary"
      dark
      slider-color="yellow"
      :value="initTab"
      @change="updateHash"
    >
      <v-tab v-for="(item, index) in items" :key="index" ripple>{{ item.name }}</v-tab>
      <v-tabs-items v-model="initTab" style="height:100%" touchless>
        <v-tab-item
          v-for="(item, index) in items"
          :key="index"
        >
            <component
              style="height:100%"
              :loading="loading"
              v-bind:is="item.component"
              :product="product"
            ></component>
        </v-tab-item>
      </v-tabs-items>
    </v-tabs>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  import ProductDetail from '@/components/Product/Detail'
  import ProductLocations from '@/components/Slotting/Products/Locations'
  import LocationSales from '@/components/Common/Product/LocationSales'
  import ProductSalesTransaction from '@/components/Slotting/Products/Transaction'
  import ProductSummary from '@/components/Common/Product/Summary'
  import productService from '@/services/slotting/product'
  import productMixin from '@/mixins/product'

  import { slottingProductTabMap } from '@/router/tabMap'
  import tabRefreshable from '@/mixins/tabRefreshable'
  import axios from 'axios'

  export default {
    components: {
      ProductDetail,
      LocationSales,
      ProductSummary,
      ProductSalesTransaction,
      ProductLocations
    },

    mixins: [
      productMixin,
      tabRefreshable(slottingProductTabMap),
    ],

    data () {
      return {
        loading: true,

        cancelFetchToken: null,

        product: {}
      }
    },

    computed: {
      ...mapGetters('acl', [
        'matchRoles'
      ]),

      items () {
        let items = []
        items.push({
          name: 'Overview',
          component: 'ProductSummary'
        })

        if (this.matchRoles(['product_management'])) {
          if (this.product.is_product_combo) {
            items.push({
              name: 'Combo',
              component: 'ProductCombo',
              props: {
                comboProduct: this.product
              }
            })
          } else {
            items.push({
              name: 'Product Detail',
              component: 'ProductDetail',
              props: {
                productData: this.product
              }
            })

            // this.items.push({
            //   name: 'Combos',
            //   component: 'ProductParentCombos',
            //   props: {
            //     productId: this.product.id
            //   }
            // })
          }
        }

        items.push({
          name: 'Locations on shelf',
          component: 'ProductLocations'
        })

        items.push({
          name: 'Sales by Location',
          component: 'LocationSales'
        })

        items.push({
          name: 'Transactions',
          component: 'ProductSalesTransaction'
        })
        return items
      },
    },

    created () {
      this.loading = true
      // const CancelToken = axios.CancelToken

      // fetch data
      productService.get(this.$route.params.id, {
        cancelToken: new axios.CancelToken(c => {
          this.cancelFetchToken = c
        })
      })
        .then(({ data }) => {
          this.product = data.data
          this.$store.commit('UPDATE_TITLE', 'Product - ' + this.getProductNameWithSku(this.product))
        })
        .catch(() => {
          // catch error
        })
        .finally(() => {
          this.loading = false
          this.cancelFetchToken = null
        })
    },

    beforeDestroy () {
      if (this.cancelFetchToken) {
        this.cancelFetchToken()
        this.cancelFetchToken = null
      }
    },
  }
</script>

<style lang="stylus">
  .v-tabs
    overflow hidden

    > .nav-tab-bar
      z-index 2
</style>



// WEBPACK FOOTER //
// src/components/Slotting/Products/Product.vue